// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3wBqR","modalForm":"UpgradeEpcsModal_modalForm__ygjyW","modalFooter":"UpgradeEpcsModal_modalFooter__2NZv-"};